import {Injectable} from '@angular/core';
import {HttpClient, HttpParams} from '@angular/common/http';
import {ParamMap} from '@angular/router';

import {Observable} from 'rxjs';
import {ErrorHandlerService} from '../error-helpers/error-handler.service';
import {catchError, debounceTime} from 'rxjs';
import {UrlUtilsService} from '../services/url-utils.service';
import {Client} from '../modules/modele/client';

@Injectable({providedIn: 'root'})
export class SigmanRestService {

    private URL_ROOT = 'api/v1/';
    private URL_CLIENTS = 'clients/';
    private URL_SIGNATURE_SESSION_END = 'docaposte/edoc/done-url';

    private RESSOURCE_SIGNATURE = '/urlSignature';

    constructor(private http: HttpClient,
                private errorHandlerService: ErrorHandlerService,
                private urlService: UrlUtilsService) {
    }

    getInformationsClient(idClientCiphered: string): Observable<any> {
        return this.http.get<Client>(
            this.urlService.getSigmanBaseUrl() + this.URL_ROOT + this.URL_CLIENTS + idClientCiphered, {observe: 'response'})
            .pipe(debounceTime(5000), catchError(this.errorHandlerService.handleError));
    }

    getUrlSignature(idClientCiphered: string, queryParamMap: ParamMap): Observable<any> {
        let params = new HttpParams();
        Object.keys(queryParamMap['params']).forEach(k => {
            params = params.set(k, queryParamMap['params'][k]);
        });

        return this.http.get(
            this.urlService.getSigmanBaseUrl()
            + this.URL_ROOT + this.URL_CLIENTS + idClientCiphered + this.RESSOURCE_SIGNATURE, {observe: 'response', params: params})
                .pipe(debounceTime(5000), catchError(this.errorHandlerService.handleError));
    }

    finalisation(transactionId: string, queryParamMap: ParamMap): Observable<any> {
        let params = new HttpParams().set('transactionId', transactionId);
        Object.keys(queryParamMap['params']).forEach(k => {
            params = params.set(k, queryParamMap['params'][k]);
        })

        return this.http.put(this.urlService.getSigmanBaseUrl() + this.URL_SIGNATURE_SESSION_END, null, {params: params})
                .pipe(debounceTime(5000), catchError(this.errorHandlerService.handleError));

    }

}
